/**
 * @name: goods-knowledge
 * @description: 商品知识库
 * @author: justin
 * @time: 2025/5/20
 */

const prefix = '/onlinecs/goodsknowledge'

/**
 * 获取商品知识库详情
 * @type {string}
 */
export const getRobotGoodsDetail = `${prefix}/queryGoodsKnowledgeDetail`

/**
 * 修改商品知识库自定义属性
 * @type {string}
 */
export const modifyCustomAttribute = `${prefix}/modifyCustomAttribute`